module.exports = __webpack_public_path__ + "img/logo.959bc8e5.png";